import { render, staticRenderFns } from "./audioLangTag.vue?vue&type=template&id=2f946709&scoped=true&"
import script from "./audioLangTag.vue?vue&type=script&lang=js&"
export * from "./audioLangTag.vue?vue&type=script&lang=js&"
import style0 from "./audioLangTag.vue?vue&type=style&index=0&id=2f946709&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f946709",
  null
  
)

export default component.exports